import React from 'react';
import XavvyFormRenderer from '../../XavvyFormRenderer';
import { registerWidget } from '../widgetRegistry';
import { useLayoutCtx } from '../LayoutContext';
import { SimpleField } from '../../CaseClient';

// Granular Add-Task widget — the launch form for the chosen task type.
// Renders the XavvyFormRenderer when launch_form_id was configured on the
// task type, or a SimpleField fallback over the task type's schema fields.
// Reads {taskType, formDef, values} from useLayoutCtx().draft and writes
// values back via setDraft.

function AddTaskForm({ config }) {
  const { token, draft, setDraft } = useLayoutCtx();
  const taskType = draft?.taskType || null;
  const formDef = draft?.formDef || null;
  const values = draft?.values || {};
  const showDescription = config.show_task_description !== false;

  if (!taskType) {
    return (
      <div style={{ padding: '12px', color: 'var(--text-secondary)', fontSize: '13px' }}>
        No task type chosen.
      </div>
    );
  }

  const fields = taskType.schema_json?.fields || [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      {showDescription && taskType.description && (
        <div style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
          {taskType.description}
        </div>
      )}
      {formDef ? (
        <XavvyFormRenderer
          token={token}
          definition={formDef}
          initialValues={values}
          onValuesChange={(vals) => setDraft({ values: vals })}
        />
      ) : fields.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {fields.map(f => (
            <SimpleField
              key={f.key}
              field={f}
              value={values[f.key]}
              onChange={(v) => setDraft({ values: { ...values, [f.key]: v } })}
            />
          ))}
        </div>
      ) : (
        <div style={{ color: 'var(--text-secondary)', fontSize: '13px', fontStyle: 'italic' }}>
          This task type takes no input — click Launch to start it.
        </div>
      )}
    </div>
  );
}

registerWidget({
  type: 'add_task.form',
  categories: ['add_task'],
  palette_label: 'Launch form',
  description: 'Task type\'s launch form (xavvy form when configured, else schema-driven SimpleField fallback). Empty-state when the task type takes no input.',
  Component: AddTaskForm,
  configSchema: {
    fields: [
      { type: 'boolean', name: 'show_task_description', label: 'Show task type description', default: true },
    ],
  },
  publishes: [],
  subscribes: [],
  group: 'Add Task',
});
